import React, { useState } from 'react'
import "../faq.css"

function FAQbox1() {

    const [activeIndex, setActiveIndex] = useState(null);

    const faqData = [
        {
            question: "Getting Started",
            answerq1: "1. What is Loyalific?",
            answer1: "Loyalific is a digital loyalty platform that lets businesses create stamp cards, rewards, and offers that customers save directly to their Apple Wallet or Google Wallet—no app download required.",

            answerq2: "2. How does Loyalific work?",
            answer2: "You create a digital loyalty card using our dashboard. Customers scan a QR code or tap a link, save the card to their wallet, and earn stamps or rewards each time they visit or make a purchase.",

            answerq3: "3. How do I sign up?",
            answer3: "Signing up is simple. Visit https://app.loopyloyalty.com/signup/get-started and follow the steps to create your account. You can start building your loyalty card as soon as you sign up.",

            answerq4: "4. Do customers need to download an app?",
            answer4: "No. Customers add your loyalty card to Apple Wallet or Google Wallet. They don't need to install an app or create an account.",

        },
        {
            question: "Managing your account",
            answerq1: "1. How do I create a loyalty card?",
            answer1: "Log in to your dashboard, choose a card type, customize the design and rewards, and publish. You'll receive a QR code and shareable link for customers.",

            answerq2: "2. How does Loyalific work?",
            answer2: "You create a digital loyalty card using our dashboard. Customers scan a QR code or tap a link, save the card to their wallet, and earn stamps or rewards each time they visit or make a purchase.",

            answerq3: "3. Can I edit my loyalty card after publishing?",
            answer3: "Yes. You can create multiple loyalty cards for different locations, brands, or campaigns. The number of active cards depends on your subscription plan.",

            answerq4: "4. How do I cancel or change my plan?",
            answer4: "You can upgrade, downgrade, or cancel your subscription at any time from your account billing settings.",
        },
        {
            question: "Pricing & Billing",
            answerq1: "1. How much does Loyalific cost?",
            answer1: "Full plan details and feature comparisons are available at https://loopyloyalty.com/pricing",

            answerq2: "2. Is there a discount for annual billing?",
            answer2: "Yes. All plans offer a discounted price when billed annually compared to monthly billing.",

            answerq3: "3. Can I change my plan later?",
            answer3: "Yes. You can move between Starter, Growth, and Ultimate plans at any time from your billing dashboard.",

            answerq4: "Do you offer refunds?",
            answer4: "No. Loyalific does not offer refunds for subscriptions or renewal charges. You can cancel at any time to prevent future billing, and your account will stay active until the end of your paid period.",
        },
        {
            question: "Security & Privacy",
            answerq1: "1. Is Loyalific secure?",
            answer1: "Yes. Loyalific follows industry-standard security practices. Loyalty cards are delivered through Apple Wallet and Google Wallet, which provide their own secure infrastructure.",

            answerq2: "2. Do you collect customer personal data?",
            answer2: "Customers do not need to create a Loyalific account to use a loyalty card. Any customer data you choose to collect is optional and fully controlled by you.",

            answerq3: "3. Can I send push notifications to customers?",
            answer3: "Yes. Wallet push notifications allow you to send updates, reminders, and offers directly to customers who have saved your loyalty card.",

            answerq4: "4. Can customers remove the loyalty card at any time?",
            answer4: "Yes. Customers can remove your loyalty card from their Apple Wallet or Google Wallet whenever they choose.",
        },

    ];

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className='faq-box1-main'>
            <div className='container'>

                <div className='home-box4-top'>
                    <h2>Questions & Answers</h2>
                    <p>Some common questions we get about Loyalific</p>
                </div>

                <div className='FAQ'>

                    {
                        faqData.map((item, index) => (
                            <div
                                className={`faq-item ${activeIndex === index ? "active" : ""}`}
                                key={index}
                            >

                                <div
                                    className='faq-question'
                                    onClick={() => toggleFAQ(index)}
                                >
                                    <h3>{item.question}</h3>

                                    <span>
                                        {activeIndex === index ? "−" : "+"}
                                    </span>
                                </div>

                                <div className='faq-answer'>
                                    <h5>{item.answerq1}</h5>
                                    <p>{item.answer1}</p>
                                    <h5>{item.answerq2}</h5>
                                    <p>{item.answer2}</p>
                                    <h5>{item.answerq3}</h5>
                                    <p>{item.answer3}</p>
                                    <h5>{item.answerq4}</h5>
                                    <p>{item.answer4}</p>
                                </div>

                            </div>
                        ))
                    }

                </div>

            </div>
        </div>
    )
}

export default FAQbox1